import { useGameStore } from '../../store';

export default function AdModal() {
  const show       = useGameStore((s) => s.showAdModal);
  const completeAd = useGameStore((s) => s.completeAd);
  const setShow    = useGameStore((s) => s.setShow);

  if (!show) return null;

  return (
    <div className="modal-backdrop" style={{ display: 'flex' }}>
      <div className="modal-sheet">
        <div className="modal-title">사또에게 청원</div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          🏛️<br /><br />사또의 은혜를 받으시오.<br />
          <strong style={{ color: 'var(--gold)', fontSize: 18 }}>+1,000만냥</strong>
        </div>
        <button className="modal-btn" onClick={completeAd}>청원하기</button>
        <button className="modal-btn ghost" onClick={() => setShow('showAdModal', false)}>
          취소
        </button>
      </div>
    </div>
  );
}
